import coercionStringToBoolean from '@main/utils/coercion-string-to-boolean';

export interface UserPresenceStatus {
  statusName: string;
  hasChannels: boolean;
  isOffline: boolean;
  statusId: string;
}

export interface UserPresenceStatusMap {
  [key: string]: UserPresenceStatus;
}

export class UserPresenceStatusStore {
  private static userPresenceStatusesMap: UserPresenceStatusMap;

  private static get statusList(): UserPresenceStatus[] {
    if (!this.userPresenceStatusesMap) {
      return [];
    }
    return Object.keys(this.userPresenceStatusesMap).map(
      (key) => this.userPresenceStatusesMap[key],
    );
  }

  static saveStatus(statuses: string) {
    const parsedStatuses = JSON.parse(statuses);

    Object.keys(parsedStatuses).forEach((key) => {
      const status = parsedStatuses[key];

      status.hasChannels = coercionStringToBoolean(status.hasChannels);
      status.isOffline = coercionStringToBoolean(status.isOffline);
    });

    this.userPresenceStatusesMap = parsedStatuses;
  }

  static getStatusById(id: string) {
    return this.userPresenceStatusesMap[id];
  }

  static getBusyStatusId() {
    const id = this.statusList.find((status) => {
      return !status.isOffline && !status.hasChannels;
    })?.statusId;

    if (!id) {
      throw new Error('Crm busy status id not found');
    }

    return id;
  }

  static getOnlineStatusId() {
    const id = this.statusList.find((status) => {
      return !status.isOffline && status.hasChannels;
    })?.statusId;

    if (!id) {
      throw new Error('Crm Online status id not found');
    }

    return id;
  }

  static getOfflineStatusId() {
    return (
      this.statusList.find((status) => {
        return status.isOffline;
      })?.statusId || '0'
    );
  }

  static isStatusOnline(statusId: string): boolean {
    return (
      this.statusList.find((status) => {
        return (
          status.statusId === statusId &&
          !status.isOffline &&
          status.hasChannels
        );
      }) !== undefined
    );
  }
}
